import { render, staticRenderFns } from "./MFormFiles.vue?vue&type=template&id=367bd4f2&scoped=true&"
import script from "./MFormFiles.vue?vue&type=script&lang=js&"
export * from "./MFormFiles.vue?vue&type=script&lang=js&"
import style0 from "./MFormFiles.vue?vue&type=style&index=0&id=367bd4f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367bd4f2",
  null
  
)

export default component.exports